// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/faq/FAQ.css
// module id = 2007
// module chunks = 0